import { ICenterItem } from './models';
import { Glyphicon, Panel } from 'react-bootstrap'
import Center from './center';

interface IProps {
    checkAllCenters: boolean,
    centerList: ICenterItem[],
    onCheckAllCenters: () => void,
    onCenterSelect: (centerId: number) => void
}

const Centers = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading style={{ textAlign: 'center', padding: '5px 10px' }}>
                <button className='btn btn-link' style={{ paddingTop: 0, paddingBottom: 0 }} onClick={props.onCheckAllCenters}>Check All Centers
                    {props.checkAllCenters ?
                        <Glyphicon glyph='check' style={{ marginLeft: 5 }} />
                        :
                        <Glyphicon glyph='unchecked' style={{ marginLeft: 5 }} />
                    }
                </button>
            </Panel.Heading>
            <Panel.Body>
                <div className='row'>
                    {props.centerList.map((item, index) =>
                        <Center
                            key={index}
                            item={item}
                            onSelect={props.onCenterSelect}
                        />
                    )}
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default Centers;